/**
 * @param marker {PropertyMarker}
 * @returns {string}
 */


export function propertyMarkerTemplateIcon(marker) {
    return `
            <div class="property-marker-icon">
                <div class="title">
                  ${marker.isFavorite} ${marker.price}
                </div>
                <div class="triangle"></div>
            </div>
            <span class="property-marker-icon-dot ${marker.attributes.isSold? 'sold' : ''}"></span>
        `;
}
